import axios from "axios";
import { BUSINESS, SERVICES } from "@/data/content";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = BUSINESS.phoneWhatsApp;

// Prefill templates per problem statement (service name injected in active language).
export function buildServiceMessage(lang, serviceKey) {
  const svc = SERVICES.find((s) => s.key === serviceKey);
  if (lang === "en") {
    const name = svc ? svc.en.name : "your services";
    return `Hi! I'd like information about prices and booking for ${name}.`;
  }
  const name = svc ? svc.no.name : "tjenestene deres";
  return `Hei! Jeg \u00f8nsker informasjon om priser og timebestilling for ${name}.`;
}

// General message (header / hero / floating widget / cta band).
export function buildGeneralMessage(lang) {
  if (lang === "en") {
    return "Hi! I'd like information about prices and booking at Beauty By Magdalena.";
  }
  return "Hei! Jeg \u00f8nsker informasjon om priser og timebestilling hos Beauty By Magdalena.";
}

// Message for a specific named treatment/package (used by the price list).
export function buildNamedMessage(lang, name) {
  if (lang === "en") {
    return `Hi! I'd like information about prices and booking for ${name}.`;
  }
  return `Hei! Jeg \u00f8nsker informasjon om priser og timebestilling for ${name}.`;
}

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

// Fire-and-forget analytics call. Only invoked when analytics consent granted.
export function trackWhatsAppClick({ serviceKey = "general", lang = "no", source = "unknown" }) {
  try {
    axios
      .post(`${API}/track/whatsapp-click`, {
        service_key: serviceKey,
        lang,
        source,
        referrer: typeof document !== "undefined" ? document.referrer : "",
      })
      .catch(() => {});
  } catch (e) {
    /* non-blocking */
  }
}
